<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
// import echarts from 'echarts'
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";
// import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "300px",
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData);

      this.chart.on("click", (param) => {
        console.log(param);
        this.$emit("chartClick", param);
      });
    },
    setOptions({ legendData, lineData } = {}) {
      this.chart.setOption({
        title: {
          text: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        xAxis: {
          type: "category",
          axisLabel: {
            interval: "auto",
            rotate: 15,
          },
          data: ["第五人民医院", "黄山卫生院", "易通路社区卫生服务中心", "兰东路社区卫生服务中心", "佳家康社区卫生服务中心", "区立医院"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [61, 55, 46, 48, 52, 26],
            type: "bar",
            // markLine: {
            //   //图表标线
            //   data: [
            //     {
            //       label: {
            //         position: "middle", // 表现内容展示的位置
            //         formatter: "平均住院日标杆值5.3", // 标线展示的内容
            //         color: "#8C8C8C", // 展示内容颜色
            //       },
            //       yAxis: "5.3",
            //     },
            //   ], //type: 'average', 平均值,  min最小值,  max 最大值,  median中位数
            // },
          },
        ],
      });
    },
  },
};
</script>
